module.exports = __webpack_public_path__ + "img/locker.bee6585.svg";